import { useFeatureFlags, useIsAppointmentGuidesEnabled } from 'hooks'
import { useIsAppointmentGuidesRoute } from '../../useAppointmentGuidesRoute'
import { AppointmentGuidesButton } from './AppointmentGuidesButton'
import { Notifications } from './Notifications'
import { Profile } from './Profile'

const UserItems = () => {
  const [isNotificationsFeedHidden] = useFeatureFlags(['HIDE_NOTIFICATIONS_FEED'])
  const isAppointmentGuidesEnabled = useIsAppointmentGuidesEnabled()
  const isAppointmentGuidesRoute = useIsAppointmentGuidesRoute()

  return (
    <>
      {!isNotificationsFeedHidden && <Notifications />}
      {isAppointmentGuidesEnabled && !isAppointmentGuidesRoute && <AppointmentGuidesButton />}
      <Profile />
    </>
  )
}

export { UserItems }
